import React, { useContext } from 'react';
import styled from 'styled-components';
import { useMutation } from '@apollo/client';
import { Form, FormBoundary } from 'core/Form';
import * as Yup from 'yup';
import { asRem } from 'lib/css';
import { FormItem } from 'core/FormFieldItem';
import { UserContext } from 'core/UserContext';
import { Box } from 'core/Box';
import { ResponseStatus, StatusError, StatusLoading } from 'core/Status';
import { RegisterMutation } from './query';

const RegisterPageWrapper = styled.div`
  margin-top: ${asRem(80)};
  .form-status {
    margin-bottom: var(--layout-padding-box);
  }
  .back-btn {
    margin-left: ${asRem(10)};
  }
`;

export function RegisterPage() {
  const userContext = useContext(UserContext);
  const formInitValues = {
    password: '',
    email: '',
    firstName: '',
    lastName: '',
  };
  const FormSchema = Yup.object().shape({
    password: Yup.string()
      .max(40, 'Password must not exceed 40 characters')
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        'Password must contain 8 Characters, one Uppercase, one Lowercase, one Number and One special case character',
      )
      .required('Password is required'),
    email: Yup.string().email('Email is invalid').required('Email is required'),
    firstName: Yup
      .string()
      .min(1)
      .max(120)
      .required('Please enter first your name'),
    lastName: Yup
      .string()
      .min(1)
      .max(120)
      .required('Please enter last your name'),
  });

  const [
    doRegister,
    { loading: registerLoading, error: registerError, data: registerData },
  ] = useMutation(RegisterMutation);

  const loading = registerLoading;
  const error = registerError;
  let status = null;
  if (registerData) {
    status = registerData.user_create.status;
  }

  const hideRegisterBlock = () => {
    userContext.setShowRegister(false);
  };

  const onSubmit = (values) => {
    doRegister({
      variables: {
        firstName: values.firstName,
        email: values.email,
        password: values.password,
        role_v2: 1001,
      },
    }).then((resp) => {
      const respData = resp && resp.data && resp.data.user_create;
      if (respData && respData.user_key) {
        console.log('Registering user');
        hideRegisterBlock();
      }
      console.log('Unexpected Response', resp);
      return false;
    });
  };

  return (
    <RegisterPageWrapper>
      <FormBoundary
        initialValues={formInitValues}
        validationSchema={FormSchema}
        onSubmit={onSubmit}
      >
        {({ submitForm }) => (
          <Box center>
            <Box.Title>Register</Box.Title>
            <Box.Content>
              <Form>
                <FormItem label="First Name" name="firstName" />
                <FormItem label="Last Name" name="lastName" />
                <FormItem label="Email" name="email" type="email" />
                <FormItem label="Password" name="password" type="password" />
                <div className="form-status">
                  {loading && (<StatusLoading message="Hold on..." />)}
                  {error && (<StatusError error={error} />)}
                  {status && (<ResponseStatus status={status} />)}
                </div>
                <button
                  className="primary plain"
                  type="button"
                  onClick={(event) => {
                    submitForm(event);
                  }}
                >
                  Register
                </button>
                <button className="plain back-btn" type="submit" onClick={hideRegisterBlock}>
                  Back
                </button>
              </Form>
            </Box.Content>
          </Box>
        )}
      </FormBoundary>
    </RegisterPageWrapper>
  );
}
